import { toErrorWithMessage } from '@repo/lib'
import * as Sentry from '@sentry/react'
import { useQuery } from 'react-query'

import StoreService from '@/store/StoreService'

export function useQuerySystemPlaylist(playlistId: string) {
  const { playlistService } = StoreService.getStore()

  const { queryFn, queryKey } = playlistService.queries.systemPlaylist

  return useQuery(queryKey(playlistId), () => queryFn(playlistId), {
    onError: caughtError => {
      const error = toErrorWithMessage(caughtError)
      console.error(error)
      Sentry.captureException(error)
      return error
    }
  })
}
